/* jshint undef: true, unused: true */
/* globals require */

var FoBuComponentFactory = require('./fobu-component-factory');

module.exports = function component (componentSettings, foBu) {

  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper;



  if (componentSettings.onClick) {
    var fnc = typeof componentSettings.onClick === 'function'
      ? componentSettings.onClick
      : foBu.settings.callableFunctions[componentSettings.onClick];
    foBu.manageEventListener(element, 'click', fnc);
  }
  wrapper.appendChild(element);


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
